import React from 'react';
import {Button} from '@material-ui/core';
import useStyles from './style.js';

const CustomButton = ({text, icon}) => {

  const classes = useStyles()

  return (
    <Button
      className={classes.customBtn}
      endIcon={icon ? <div className={classes.btnIcon}>{icon}</div> : null}
    >
      <span className={classes.btnText}>{text}</span>
    </Button>
  );
};

export default CustomButton;
